/* eslint-disable max-len */

export const LANG_RU = Object.freeze({
    'Ленинградская область': 'Ленинградская область',

    'Русский': 'Русский',
    'English': 'English',
    // -- карта
    'km': 'км',
    'm': 'м',
    // -- инструменты
    'LOCATION': 'Координата',
    'DISTANCE': 'Расстояние',
    'AREA': 'Площадь',
    'RADIUS': 'Радиус',

    'OBJECTS_COUNT_0': '{{count, number}} объект',
    'OBJECTS_COUNT_1': '{{count, number}} объекта',
    'OBJECTS_COUNT_2': '{{count, number}} объектов',

    'FILES_COUNT_0': '{{count, number}} файл',
    'FILES_COUNT_1': '{{count, number}} файла',
    'FILES_COUNT_2': '{{count, number}} файлов',

    'LICENSE_AGREEMENT': 'Нажимая на кнопку, вы даете согласие на обработку персональных данных в соответствии с условиями <a href="https://map.lenoblinvest.ru/terms_of_use/" rel="noopener noreferrer" target="_blank">пользовательского соглашения</a> и <a href="https://map.lenoblinvest.ru/privacy_policy/" rel="noopener noreferrer" target="_blank"> политикой конфиденциальности</a>',

    'POWER_FILTER_LABEL_DISTANCE': 'Расстояние',
    'POWER_FILTER_LABEL_FREE_POWER': 'Свободная мощность',
    'POWER_FILTER_FREE_BANDWIDTH': 'Свободная пропускная способность',
    'POWER_FILTER_VALUE': '{{distance, number}} {{units}}',

    'list': 'Список | {{count, number}}',
    'Подбор площадки': 'Подбор площадки',

    'Избранные свободные инвестиционные площадки': 'Избранные свободные инвестиционные площадки',
    'Избранные индустриальные парки': 'Избранные индустриальные парки',
    'Избранные проекты': 'Избранные проекты',
    'Избранные объекты программ развития': 'Избранные объекты программ развития',

    'Презентации': 'Презентации',

    // -- мобильная версия
    'Список слоёв': 'Список слоёв',
    'Базовая карта': 'Базовая карта',

    // -- фиксированные маштабы
    'Мир': 'Мир',
    'Страна': 'Страна',
    'Регион': 'Регион',
    'Площадки': 'Площадки',
    'Проекты': 'Проекты',
    'Планы': 'Планы',
    'Потенциал': 'Потенциал',


    // 'Печать': 'Печать',
    // 'Скачать изображение': 'Скачать изображение',
    'Ссылка': 'Ссылка',

    // -- скачать изображение
    'Оригинал': 'Оригинал',
    'Заголовок': 'Заголовок',
    'Легенда': 'Легенда',
    'Скачать в PNG': 'Скачать в PNG',
    'Скачать в JPEG': 'Скачать в JPEG',

    // -- сообщить об ошибке
    'Сообщить об ошибке': 'Сообщить об ошибке',
    'Отправить': 'Отправить',

    // -- кнопки
    'OK': 'OK',
    'Отмена': 'Отмена',
    'нет': 'нет',
    'Повторить': 'Повторить',

    // -- поиск
    // 'Объекты': 'Объекты',
    // 'Адрес': 'Адрес',
    'ПКК': 'ПКК',
    // 'Нет результатов для данного запроса': 'Нет результатов для данного запроса',
    // для omjs виджета поиска
    // 'По вашему запросу ничего не найдено': 'Нет результатов для данного запроса',
    // 'Произошла ошибка на стороне сервера': 'Произошла ошибка на стороне сервера',
    // 'Слой карты': 'Слой карты',

    // -- расстояние
    'км': 'км',
    'м': 'м',

    // -- масштабная линейка
    ' км': ' км',
    ' м': ' м',
    ' мм': ' мм',
    ' миль': ' миль',
    ' фут': ' фут',
    ' дюйм': ' дюйм',

    // -- панель
    'Фильтровать': 'Фильтровать',
    'Сбросить фильтр': 'Сбросить фильтр',
    'Список': 'Список',
    'По умолчанию': 'По умолчанию',

    'Общая информация': 'Общая информация',
    'Свободные площади для резидентов ТОСЭР': 'Свободные площади для резидентов ТОСЭР',

    // -- список объектов
    'Выгрузить в Excel': 'Выгрузить в Excel',

    // -- информационное окно
    'Назад': 'Назад',
    'Описание': 'Описание',
    'Медиа': 'Медиа',
    'Документы': 'Документы',
    'Слои': 'Слои',
    'Прозрачность': 'Прозрачность',
    'Добавить в избранное': 'Добавить в избранное',
    'Удалить из избранного': 'Удалить из избранного',
    'Приблизить': 'Приблизить',
    'Скачать PDF': 'Скачать PDF',
    'Отобразить возможность подключения на карте': 'Отобразить возможность подключения на карте',
    'Скачать xls': 'Скачать xls',

    // -- фильтры
    'Перейти к списку': 'Перейти к списку',
    'Выбрано объектов:': 'Выбрано объектов:',
    'Выбрано': 'Выбрано',

    // -- ссылка
    'Ссылка скопирована в буфер обмена': 'Ссылка скопирована в буфер обмена',
    'Ссылка на карту': 'Ссылка на карту',
    'Ссылка на объект': 'Ссылка на объект',

    // --Сортировка
    'Название': 'Название',


    'Не выбрано': 'Не выбрано',

    // -- фильтры
    'Фильтры': 'Фильтры',
    'от': 'от',
    'до': 'до',
    'млн руб.': 'млн руб.',
    'млн.': 'млн.',
    'млрд.': 'млрд.',
    'га': 'га',
    'руб': 'руб.',
    'МВт': 'МВт',
    'чел.': 'чел.',
    'тыс.м3/час': 'тыс.м3/час',

    // -- кадастровая карта
    'Номер': 'Номер',
    'Районов': 'Районов',
    'Кварталов': 'Кварталов',
    'Участков': 'Участков',
    'Дата': 'Дата',
    'Кадастровая карта': 'Кадастровая карта',
    'Информация по объекту': 'Информация по объекту',
    'Кадастровый номер': 'Кадастровый номер',
    'Наименование': 'Наименование',
    'Нет данных': 'Нет данных',

    'Эта функция недоступна при использовании карт Яндекс или Спутниковых снимков в качестве подложки': 'Эта функция недоступна при использовании карт Яндекс или Спутниковых снимков в качестве подложки',

    // -- обратная связь
    'Имя': 'Имя',
    'Электронная почта': 'Электронная почта',
    'Сообщение': 'Сообщение',
    'Прикрепить файл': 'Прикрепить файл',
    'Введите код': 'Введите код',
    'Изменить': 'Изменить',
    'Код проверки': 'Код проверки',
    'Размер загружаемого файла превышает 2 МБ': 'Размер загружаемого файла превышает 2 МБ',
    'Обратная связь': 'Обратная связь',
    'Сообщение отправлено': 'Сообщение отправлено',
    'Следующие поля заполнены неверно': 'Следующие поля заполнены неверно',

    // -- заявка на подбор площадки
    'ФИО': 'ФИО',
    'Телефон': 'Телефон',
    'Заявка на подбор инвестиционной площадки': 'Заявка на подбор инвестиционной площадки',
    'Заявка на подбор площадки': 'Заявка на подбор площадки',
    'Описание проекта': 'Описание проекта',
    'Требования к площадке': 'Требования к площадке',

    'Перейти к проекту': 'Перейти к проекту',
    'О регионе': 'О регионе',
    'Избранное': 'Избранное',
    'Помощь': 'Помощь',
    'Подписаться': 'Подписаться',
    'Войти': 'Войти',
    'Выйти': 'Выйти',
    'Ошибка авторизации': 'Ошибка авторизации',
    'Код ошибки': 'Код ошибки',
    'Логин': 'Логин',
    'Пароль': 'Пароль',
    'введите ваш email': 'введите ваш email',
    'Вы подписались на изменения': 'Вы подписались на изменения',
    'Вы уже подписаны  на этот объект': 'Вы уже подписаны  на этот объект',
    'Введен некорректный e-mail': 'Введен некорректный e-mail',

    'О проекте': 'О проекте',
    'Программы развития': 'Программы развития',
    'Льготы': 'Льготы',
    'Преимущества Ленинградской области': 'Преимущества Ленинградской области',
    'По вашему запросу ничего не найдено': 'По вашему запросу ничего не найдено',
    'Превышено количество объектов для выгрузки.Максимальное количество - 500 объектов.Для уменьшения количества объектов можете воспользоваться фильтром.': 'Превышено количество объектов для выгрузки. Максимальное количество - 500 объектов. Для уменьшения количества объектов можете воспользоваться фильтром.',
    'Поле обязательно для заполнения': 'Поле обязательно для заполнения',
    'Гринфилд': 'Гринфилд',
    'Браунфилд': 'Браунфилд',
    'Предложение для девелоперов': 'Предложение для девелоперов',
    'Туристско-рекреационные': 'Туристско-рекреационные',
    'Туристско-рекреационная': 'Туристско-рекреационная',
    'Скачать приложение': 'Скачать приложение',
    'Авторизация': 'Авторизация',
    'Инвестиционное развитие территории Ленинградской области': 'Инвестиционное развитие территории Ленинградской области',
    'Инвестиционный портал Ленинградской области': 'Инвестиционный портал Ленинградской области',
    'Региональная информационная система': 'Региональная информационная система',
    'Скачать': 'Скачать',
    'Ошибка загрузки': 'Ошибка загрузки',
    'Сравнение площадок': 'Сравнение площадок',
    'Функциональные возможности системы': 'Функциональные возможности системы',
    'Ошибка': 'Ошибка',
    'Выход': 'Выход',

    // -- фильтр подбора площадки
    'подбор площадки': 'подбор площадки',
    'Cбросить фильтр': 'Cбросить фильтр',
    'Далее': 'Далее',
    'Показать список': 'Показать список',
    'показать список': 'показать список',
    'скачать в excel': 'скачать в excel',
    'показать на карте': 'показать на карте',
    'Показать на карте': 'Показать на карте',
    'Основное': 'Основное',
    'Наличие инфраструктуры': 'Наличие инфраструктуры',
    'Местоположение': 'Местоположение',
    'Дополнительно': 'Дополнительно',
    'Собственник': 'Собственник',
    'Контактное лицо': 'Контактное лицо',
    'свободные инвестиционные площадки': 'свободные инвестиционные площадки',
    'Закрыть': 'Закрыть',
    'Изменить тип списка': 'Изменить тип списка',
    'Очистить фильтр': 'Очистить фильтр',
    'Предыдущая вкладка': 'Предыдущая вкладка',
    'Следующая вкладка': 'Следующая вкладка',
    'Открыть список отфильтрованных объектов': 'Открыть список отфильтрованных объектов',
    'Скачать отфильтрованные объекты в формате excel': 'Скачать отфильтрованные объекты в формате excel',
    'Приблизиться к отфильтрованным объектам': 'Приблизиться к отфильтрованным объектам',
    'Подбор индустриального парка': 'Подбор индустриального парка',
    'Подбор свободной инвестиционной площадки': 'Подбор свободной инвестиционной площадки',
    'Обучающее видео': 'Обучающее видео',
    'тип площадки': 'тип площадки',
    'Инфраструктура': 'Инфраструктура',
    'Справка': 'Справка',
    'Земельные участки в аренду': 'Земельные участки в аренду',
    'Пожалуйста, поверните ваше устройство горизонтально': 'Пожалуйста, поверните ваше устройство горизонтально',
    'Подобрать свободную площадку': 'Подобрать свободную площадку',
    'Навигатор мер поддержки': 'Навигатор мер поддержки',
    'Объекты связи': 'Объекты связи',
    'Субсидии в АПК': 'Субсидии в АПК',
    'Финансовая поддержка МСП': 'Финансовая поддержка МСП',
    'В 2017 году осуществлена интеграция сведений об инвестиционных объектах из Интегрированной региональной информационной системы(далее – ИРИС) c геоинформационной системой «Фонд пространственных данных Ленинградской области».': 'В 2017 году осуществлена интеграция сведений об инвестиционных объектах из Интегрированной региональной информационной системы(далее – ИРИС) c геоинформационной системой «Фонд пространственных данных Ленинградской области».',
    'Развернуть': 'Развернуть',
    'Свернуть': 'Свернуть',
    'В 2019 году для подбора инвестором свободных инвестиционных площадок разработан пошаговый фильтр.В магазинах приложений AppStore и Google Play опубликованы приложения адаптивной версии Карты ИРИС для смартфонов.': 'В 2019 году для подбора инвестором свободных инвестиционных площадок разработан пошаговый фильтр.В магазинах приложений AppStore и Google Play опубликованы приложения адаптивной версии Карты ИРИС для смартфонов.',
    'референт заместителя Председателя Правительства Ленинградской области': 'референт заместителя Председателя Правительства Ленинградской области',
    'Разместить производство': 'Разместить производство',
    'Подбор свободной площадки для инвестирования': 'Подбор свободной площадки для инвестирования',
    'Инвестиционный потенциал территории': 'Инвестиционный потенциал территории',
    'Перспективы развития территории': 'Перспективы развития территории',
    'Общие сведения о территории': 'Общие сведения о территории',
    'Сравнить': 'Сравнить',
    'Объекты для сравнения отсутствуют': 'Объекты для сравнения отсутствуют',
    'Вернуться на сайт': 'Вернуться на сайт',
    'Скачать список': 'Скачать список',
    'Оглавление': 'Оглавление',
    'Получить консультацию': 'Получить консультацию',
    'Вход': 'Вход',
    'Введите слово': 'Введите слово',
    'Подать заявку': 'Подать заявку',
    'Организация': 'Организация',
    'Площадь земельного участка': 'Площадь земельного участка',
    'Введите слово с картинки': 'Введите слово с картинки',
    'Поиск': 'Поиск',
    'Объекты': 'Объекты',
    'Адрес': 'Адрес',
    'Найдено площадок': 'Найдено площадок',
    'Сбросить': 'Сбросить',
    'Тип площадки': 'Тип площадки',
    'Возможность подключения к центрам питания': 'Возможность подключения к центрам питания',
    'Возможность подключения к газоснабжению': 'Возможность подключения к газоснабжению',
    'Заявка на обновление данных': 'Заявка на обновление данных',
    'Выберите слой для выгрузки': 'Выберите слой для выгрузки',
    'Выгрузить': 'Выгрузить',
    'Пространственный раздел стратегии': 'Пространственный раздел стратегии',
    'Существующие промышленные предприятия': 'Существующие промышленные предприятия',
    'Экономическая специализация': 'Экономическая специализация',
    'Социально - экономическое зонирование': 'Социально - экономическое зонирование',
    'Существующая специализация': 'Существующая специализация',
    'Перспективная специализация': 'Перспективная специализация',
    'Зона контролируемой агломерации': 'Зона контролируемой агломерации',
    'Подцентры агломерации': 'Подцентры агломерации',
    'Другие территории агломерации': 'Другие территории агломерации',
    'Точки роста': 'Точки роста',
    'Малые агломерации': 'Малые агломерации',
    'Зоны равновесия': 'Зоны равновесия',
    'Отдаленные территории': 'Отдаленные территории',
    'Исторические поселения': 'Исторические поселения',
    'Демографическая ситуация и прогноз': 'Демографическая ситуация и прогноз',
    'Динамика численности населения': 'Динамика численности населения',
    'Доля численности населения': 'Доля численности населения',
    'Численность постоянного населения, тыс.чел.': 'Численность постоянного населения, тыс.чел.',
    'Доля численности МО в общей численности Ленинградской области, %': 'Доля численности МО в общей численности Ленинградской области, %',
    'Прогнозная численность постоянного населения, тыс.чел.': 'Прогнозная численность постоянного населения, тыс.чел.',
    'Балансовая принадлежность': 'Балансовая принадлежность',
    'Максимально используемая мощность по результатам замеров почасовых объемов потребления, МВт': 'Максимально используемая мощность по результатам замеров почасовых объемов потребления, МВт',
    '"Текущий резерв/ дефицит мощности,': '"Текущий резерв/ дефицит мощности,',
    '"Текущий резерв/дефицит мощности для технологического присоединения,': '"Текущий резерв/дефицит мощности для технологического присоединения,',
    'Ссылка на "личный кабинет" территориальной сетевой организации': 'Ссылка на "личный кабинет" территориальной сетевой организации',
    'Расчет стоимости технологического присоединения': 'Расчет стоимости технологического присоединения',
    'Класс предприятия в соответствии с разделом VII.2 Приказа Минэкономразвития России от 09.01.2018 № 10': 'Класс предприятия в соответствии с разделом VII.2 Приказа Минэкономразвития России от 09.01.2018 № 10',
    'Вид экономической деятельности по ОКВЭД': 'Вид экономической деятельности по ОКВЭД',
    'Среднесписочная численность сотрудников, чел.': 'Среднесписочная численность сотрудников, чел.',
    'no-internet': 'Проверьте подключение к интернету и попробуйте ещё раз',
    'Повтор': 'Повтор',
    //
    'Email указан неверно': 'Email указан неверно',
    'Для управления слоями приблизьтесь к территории': 'Для управления слоями приблизьтесь к территории',

    'Скрыть объекты': 'Скрыть объекты',

    // Заголовки страниц
    'root': 'Инвестиционные площадки, парки, проекты и инфраструктура на карте Ленобласти',
    'select': 'Подбор свободной площадки для инвестирования в Ленинградской области',
    'potential': 'Инвестиционный потенциал территории Ленинградской области',
    'info': 'Общие сведения о территории Ленинградской области',
    'prospects': 'Перспективы развития территории и стратегия Ленинградской области',
    'folder5': 'Проекты',
    'folder6': 'Инфраструктура (ЛК)',

    // Баннер
    'Санкт-Петербург, Малоохтинский проспект, дом 64, литера Б, офис 402': 'Санкт-Петербург, Малоохтинский проспект, дом 64, литера Б, офис 402',
    'Имущество для МСП': 'Имущество для МСП',
    'Имущество для бизнеса': 'Имущество для бизнеса',
    'Аренда и продажа з/у. Торги': 'Аренда и продажа з/у. Торги',
    'Тарифы': 'Тарифы',
    'На сайт': 'На сайт',
    'Список пуст': 'Список пуст',
    'Администрирование': 'Администрирование'
});
